export const REGEX_POSITIVE_INT = /^[1-9]\d*$/;
export const REGEX_POSITIVE_FLOAT = /^(?:\d+(?:\.\d+)?|)$/;
